import React from 'react';

import { listBibsRowConfigShape } from 'app/shapes/browse';
import { BibsRowBibs } from 'app/components/browse/shared/BibsRowBibs';

const ListBibsRow = ({ config }) => {
  const { displayBibs, hasHistoryRoutingForTitles, list, trackBibClick, trackTitleClick } = config;
  const listUrl = `/list/share/${list.owner}/${list.id}`;
  const title = list.name;

  return (
    <div className="cp-list-bibs-row">
      <BibsRowBibs
        displayBibs={displayBibs}
        hasHistoryRoutingForTitles={hasHistoryRoutingForTitles}
        title={title}
        titleUrl={listUrl}
        trackBibClick={trackBibClick}
        trackTitleClick={trackTitleClick}
      />
    </div>
  );
};

ListBibsRow.propTypes = {
  config: listBibsRowConfigShape.isRequired
};

export default ListBibsRow;
